// import { createRouter, createWebHistory } from 'vue-router'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Root from './pages/Root'
import Atlas from './pages/Atlas'
import Profile from './pages/Profile'
import Skills from './pages/Skills'
import Economica from './pages/Economica'
import Politica from './pages/Politica'
import Adminstraion from './pages/Adminstraion'
import Learning from './pages/Learning'
import Awards from './pages/Awards'
import Statistic from './pages/Statistic'
import Ship from './pages/Ship'
import Hangar from './pages/Hangar'
import HangarShip from './pages/HangarShip'
import Shipyard from './pages/Shipyard'

const routes = [
  { path: '/', name: 'root', component: Root },
  { path: '/atlas', name: 'atlas', component: Atlas },
  { path: '/atlas/orbit', name: 'orbit', component: Atlas },
  { path: '/atlas/surface', name: 'surface', component: Atlas },
  { path: '/atlas/system', name: 'solarSystem', component: Atlas },
  { path: '/atlas/galaxy', name: 'galaxy', component: Atlas },
  { path: '/economica', name: 'economica', component: Economica },
  { path: '/economica/markets', name: 'markets', component: Economica },
  { path: '/economica/productions', name: 'productions', component: Economica },
  { path: '/adminstraion', name: 'adminstraion', component: Adminstraion },
  { path: '/adminstraion/news', name: 'news', component: Adminstraion },
  { path: '/adminstraion/quests', name: 'quests', component: Adminstraion },
  { path: '/politica', name: 'politica', component: Politica },
  { path: '/politica/clans', name: 'clans', component: Politica },
  { path: '/politica/myclan', name: 'myclan', component: Politica },
  { path: '/profile', name: 'profile', component: Profile },
  { path: '/profile/skills', name: 'skills', component: Skills },
  { path: '/profile/learning', name: 'learning', component: Learning },
  { path: '/profile/awards', name: 'awards', component: Awards },
  { path: '/profile/statistic', name: 'statistic', component: Statistic },
  { path: '/ship', name: 'ship', component: Ship },
  { path: '/ship/hangar', name: 'hangar', component: Hangar },
  { path: '/ship/hangar/:id', name: 'hangarShip', component: HangarShip },
  { path: '/ship/shipyard', name: 'shipyard', component: Shipyard },
];

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/game',
  routes
})

export default router
